const en = {
  "Home": "Home",
  "Add": "Add",
  "Adding": "Adding",
  "Editing": "Editing",
  "Edit": "Edit",
  "Delete": "Delete",
  "Save": "Save",
  "Cancel": "Cancel",
  "Close": "Close",
  "Open": "Open",
  'View': 'View',
  'Remove': 'Remove',
  'Medicines': 'Medicines',
  'Medicine': 'Medicine',
  'OverviewAbout': 'What is and what it is used for',
  'OverviewBeforeIntake': 'What you need to know before your child receives',
  'OverviewDosage': 'How is given',
  'OverviewSideEffects': 'Possible side effects',
  'OverviewSafetyData': 'How to store',
  'OverviewAdditionalInfo': 'Contents of the pack and other information',
  'LeafletUserInfo': 'Package leaflet: Information for the user',
  'WhatIsInLeaflet': 'What is in this leaflet:',
  'WhatIsInProduct': 'What is in',
  'ActiveIngredients': 'Active ingredients',
  'WhatLooksAndPackageContents': 'What looks like and contents of the pack',
  'FirstSideImprint': 'imprinted on one side with',
  'NotAllPackagesMarketed': 'Не всички видове опаковки могат да бъдат пуснати в продажба.',
  'MarketingAuthorisationHolderAndManufacturer': 'Marketing Authorisation Holder and Manufacturer',
  'MarketingAuthorisationHolder': 'Marketing Authorisation Holder',
  'Manufacturer': 'Manufacturer',
  'BrandName': 'Brand Name',
  'GenericName': 'Generic Name',
  'Overview': 'Overview',
  'SideEffects': 'Side Effects',
  'Dosage': 'Dosage',
  'Professional': 'Professional',
  'Interactions': 'Interactions',
  'Interactions with': 'Interactions with',
  'interactions': 'interactions',
  'Leaflet': 'Leaflet',
  'InactiveIngredients': 'Inactive ingredients',
  'LeafletForUser': 'User Leaflet',
  'SmPC': 'Summary of product characteristics',
  'Leaflets': 'Leaflets',
  'FilesForDownload': 'Files for download',
  'PharmaceuticalForm': 'Pharmaceutical Form',
  'Imprint': 'Imprint',
  'Strength': 'Strength',
  'Color': 'Color',
  'Size': 'Size',
  'Shape': 'Shape',
  'Packiging': 'Packiging',
  'PackegeSize': 'Packege Size',
  'DDD': 'DDD',
  'RouteOfAdministration': 'Route of Administration',
  'ProductInformation': 'Product Information',
  'ProductType': 'Product Type',
  'ItemCode': 'Item Code',
  'Name': 'Name',
  'BasisOfStrength': 'Basis of Strength',
  'ProductCharacteristics': 'Product characteristics',
  'MarketingInformation': 'Marketing information',
  'FirstAuthorizationDate': 'First authorization date',
  'LastAuthorizationDate': 'Last authorization date',
  'Score': 'Score',
  'Flavor': 'Flavor',
  'Contains': 'Contains',
  'MedicineIndexAtoZ': 'Medicine Index A to Z',
  'MedicineBrowseText': 'The resources below have been provided to help narrow your search to specific, targeted drug information. Information is available for both consumers and healthcare professionals on over 24,000 prescription and over the counter medicines.',
  'BrowseAllMedicine': 'All medicines list',
  'CheckMedicineInteractions': 'Check medicines interactions',
  'SearchMedicineInDatabase': 'Search by medicine name or active ingredient name',
  'BrowseAlphabetically': 'Browse Alphabetically',
  'BrowseMedicinesByCategory': 'Browse Medicines by Category',
  'Top40MedicineSearches': 'Top 10 Medicine Searches',
  'Pregnancy': 'Pregnancy',
  'Breastfeeding': 'Breastfeeding',
  'Pregnancy&Breastfeeding': 'Pregnancy & Breastfeeding',
  'EnterMedicineName': 'Medicine or active ingredient',
  'MedicineListDescription': 'Drugs and medications listed by brand and/or generic name.',
  'MedicineListDescriptionStartWith': 'Drugs and medications listed by brand and/or generic name starting with the letter',
  'MedicineListDescriptionBySearchText': 'Drugs and medications listed by brand and/or generic name which contain searched text',
  'MedXchangeDescription': 'MedXchange is a treatment assistant that provides detailed information on the content and interaction of substances in medicinal products with other medicines, foods and diseases.',
  'CanNotFindYourMedicine': 'Can\'t find your medication?',
  'ResulFound': 'records found.',
  'Major': 'Major',
  'Moderate': 'Moderate',
  'Minor': 'Minor',
  'Unknown': 'Unknown',
  'DrugInteractionClassification': 'Drug Interaction Classification',
  'DrugInteractionClassificationDescription': 'The classifications below are a general guideline only. It is difficult to determine the relevance of a particular drug interaction to any individual given the large number of variables.',
  'DrugInteractionClassificationMajor': 'Highly clinically significant. Avoid combinations; the risk of the interaction outweighs the benefit.',
  'DrugInteractionClassificationModerate': 'Moderately clinically significant. Usually avoid combinations; use it only under special circumstances.',
  'DrugInteractionClassificationMinor': 'Minimally clinically significant. Minimize risk; assess risk and consider an alternative drug, take steps to circumvent the interaction risk and/or institute a monitoring plan.',
  'DrugInteractionClassificationUnknown': 'No information available.',
  'DrugInteractionClassificationDoNotStop': 'Do not stop taking any medications without consulting your healthcare provider.',
  'DrugInteractions': 'Drug Interactions',
  'Alcohol/FoodInteractions': 'Alcohol/Food Interactions',
  'DiseaseInteractions': 'Disease Interactions',
  'DriveMachineInteractions': "Drive/Machine Interactions",
  'drive/machineInteractions': "drive/machine interactions",
  'A total of %s drugs (%s brand and generic names) are known to interact with ': 'A total of %s drugs (%s brand and generic names) are known to interact with ',
  'drug interactions': 'drug interactions',
  'brand and generic names': 'brand and generic names',
  'Show all medications in the database that may interact with': 'Show all medications in the database that may interact with',
  'with': 'with',
  'Alcohol and food interactions with': 'Alcohol and food interactions with',
  'Disease interactions with': 'Disease interactions with',
  'There are': 'There are',
  'Drug interactions between %s and %s': 'Drug interactions between %s and %s',
  'Switch to professional interaction data': 'Switch to professional interaction data',
  'Switch to consumer interaction data': 'Switch to consumer interaction data',
  'Consumer': 'Consumer',
  'Drug interactions with': 'Drug interactions with',
  'Summary': 'Summary',
  'For the Consumer': 'For the Consumer',
  'Overdose Description': 'Overdose Description',
  'For Healthcare Professionals': 'For Healthcare Professionals',
  'Other Information': 'Other Information',
  'Other Comments': 'Other Comments',
  'Precautions': 'Precautions',
  'Dose Adjustments': 'Dose Adjustments',
  'Very Common': 'Very Common',
  'Common': 'Common',
  'Uncommon': 'Uncommon',
  'Rare': 'Rare',
  'Very rare': 'Very rare',
  'Frequency not reported': 'Frequency not reported',
  'Postmarketing reports': 'Postmarketing reports',
  '10% or more': '10% or more',
  '1% to 10%': '1% to 10%',
  '0.1% to 1%': '0.1% to 1%',
  '0.01% to 0.1%': '0.01% to 0.1%',
  '0.001% to 0.01': '0.001% to 0.01',
  'usual dose for': 'usual dose for',
  'Adult': 'Adult',
  'Pediatric': 'Pediatric',
  'Comments': 'Comments',
  'Uses': 'Uses',
  'Maximum dose': 'Maximum dose',
  'Duration of therapy': 'Duration of therapy',
  'Implant': 'Implant',
  'Inhalation': 'Inhalation',
  'Instillation': 'Instillation',
  'Nasal': 'Nasal',
  'Oral': 'Oral',
  'Parenteral': 'Parenteral',
  'Rectal': 'Rectal',
  'Sublingual/buccal/oromucosal': 'Sublingual/buccal/oromucosal',
  'Transdermal': 'Transdermal',
  'Vaginal': 'Vaginal',
  'Human drug': 'Human drug',
  'Login': 'Login',
  'Email': 'Email',
  'Password': 'Password',
  'New to MedXchange?': 'New to MedXchange?',
  'or login with': 'or login with',
  'Forgot password?': 'Forgot password?',
  'Create a New Account': 'Create a New Account',
  'Confirm Password': 'Confirm Password',
  'Create': 'Create',
  'Please accept personal data private Policy': 'Please accept personal data private Policy',
  'Accept': 'Accept',
  'personal data protection policy': 'personal data protection policy',
  'Please enter your email.': 'Please enter your email.',
  'Send': 'Send',
  'Invalid E-mail or Password.': 'Invalid E-mail or Password.',
  'Invalid E-mail.': 'Invalid E-mail.',
  '4000': 'User item not found.',
  '4001': 'Old Password is invalid',
  '4002': 'New Password nad Confirm Password are not same.',
  '4003': 'Already exist User with this Email',
  '4004': 'Not valid e-mail address',
  '4005': 'Not valid or expired link',
  '4006': 'Not valid E-mail for this link',
  'Change': 'Change',
  'Change Password': 'Change Password',
  'Old Password': 'Old Password',
  'New Password': 'New Password',
  'Please enter Old Password': 'Please enter Old Password',
  'Please enter New Password': 'Please enter New Password',
  'Please enter Confirm Password': 'Please enter Confirm Password',
  'New Password and Confirm Password are different': 'New Password and Confirm Password are different',
  'Password and Confirm Password are different': 'Password and Confirm Password are different',
  'Profile': 'Profile',
  'My Medicine': 'My Medicine',
  'My Medicines': 'My Medicines',
  'My Diseases': 'My Diseases',
  'Logout': 'Logout',
  'Please enter Password': 'Please enter Password',
  'Please enter Email': 'Please enter Email',
  'Please enter valid Email': 'Please enter valid Email',
  'Please enter Name': 'Please enter Name',
  'You have successfully changed your Password.': 'You have successfully changed your Password.',
  'You have successfully saved your data.': 'You have successfully saved your data.',
  'You have successfully logged in.': 'You have successfully logged in.',
  'You have successfully created a new account.': 'You have successfully created a new account.',
  'Now you can go to ': 'Now you can go to ',
  'Check your E-mail box to confirm registration and activate your account.': 'Check your E-mail box to confirm registration and activate your account.',
  'You have successfully activated your account.': 'You have successfully activated your account.',
  'Sorry but your activation link is not valid or expired.': 'Sorry but your activation link is not valid or expired.',
  'We have sent an E-mail to you.': 'We have sent an E-mail to you.',
  'Please check your E-mail box and click on confirmation link to change your password.': 'Please check your E-mail box and click on confirmation link to change your password.',
  'Enter new Password': 'Enter new Password',
  'Disease': 'Disease',
  'Disease Type': 'Disease Type',
  'Start Date': 'Start Date',
  'End Date': 'End Date',
  'Actions': 'Actions',
  'Select': 'Select',
  'Save & Close': 'Save & Close',
  'No Selection': 'No Selection',
  'Disease code': 'Disease Code',
  'Disease name': 'Disease Name',
  'Filter': 'Filter',
  'Clear': 'Clear',
  'InfectiousDisease': 'Infectious Disease',
  'DeficiencyDisease': 'Deficiency Disease',
  'HereditaryDisease': 'Hereditary Disease',
  'PhysiologicalDisease': 'Physiological Disease',
  'ChronicDisease': 'Chronic Disease',
  'Single Dose': 'Single Dose',
  'Frequency Of Intake': 'Frequency Of Intake',
  'Intake Conditions': 'Intake Conditions',
  'Alarms': 'Alarms',
  'Medicine Number': 'Medicine Number',
  'Number': 'Number',
  'Additional Title': 'Additional Title',
  'Diseases': 'Diseases',
  'Prescriptions': 'Prescriptions',
  'My Prescriptions': 'Recommendations from Doctor',
  'Profession': 'Profession',
  'Driver': 'Driver',
  'MachineOperator': 'Machine Operator',
  'Prescription': 'Prescription',
  'Doctor': 'Doctor',
  'Hospital': 'Hospital',
  'All Medicines': 'All Medicines',
  'All Diseases': 'All Diseases',
  'Selected': 'Selected',
  'Your Information': 'My Information',
  'Download Your Information': 'Download Your Information',
  'DownloadYourInformationDescription': "You can download a copy of your MedXchange information at any time. You can download all of it at once in a JSON format, which could allow another service to more easily import it. If you'd like to view your information without downloading it, you can access your information at any time.",
  'Download': 'Download',
  'Delete Account': 'Delete Account',
  'Permanently Delete Account': 'Permanently Delete Account',
  'DeleteAccountPermanentlyDescription': "You can permanently delete your MedXchange account at any time. Once the deletion process begins, you won't be able to reactivate your account or retrieve any of the content or information you have added.",
  'Are you sure that you want to delete your Account permanently?': 'Are you sure that you want to delete your Account permanently?',
  'Confirm Dialog': 'Confirm Dialog',
  'Yes': 'Yes',
  'No': 'No',
  '5000': 'Selected disease already exists in user list.',
  '5001': 'Selected medicine already exists in user list.',
  'Disease History': 'Disease History',
  'Medicine History': 'Medicine History',
  '5002': 'User disease not found.',
  '5003': 'User medicine not found.',
  'My Family': 'My Family',
  'Cookies Policy': 'Cookies Policy',
  'Personal Data Policy': 'Personal Data Policy',
  'Check': 'Check',
  'Result': 'Result',
  'Start with': 'Start with',
  'Selected medicine already exist in list.': 'Selected medicine already exist in list.',
  'Male': 'Male',
  'Female': 'Female',
  'ZeroNeagtive': '0-',
  'ZeroPositive': '0+',
  'ANegative': 'A-',
  'APositive': 'А+',
  'BNegative': 'B-',
  'BPositive': 'B+',
  'ABNegative': 'AB-',
  'ABPositive': 'AB+',
  'Gender': 'Gender',
  'Blood Type': 'Blood Type',
  'Personal Data': 'Personal Data',
  'Account': 'Account',
  'Height (cm)': 'Height (cm)',
  'Weight (kg)': 'Weight (kg)',
  'Birthdate': 'Birthdate',
  'Other parameters': 'Other parameters',
  'Add medicine to check interactions.': 'Add medicine to check interactions.',
  'Other parameters interactions': 'Other parameters interactions',
  'There is no drug interactions.': 'There is no drug interactions.',
  'There is no diseases interactions.': 'There is no diseases interactions.',
  'There is no other interactions.': 'There is no other interactions.',
  'EnterDiseaseName': 'Enter Disease Name',
  'EnterDiseaseCode': 'Enter Disease Code',
  'StartEndDate': 'Start - end date',
  'DoseTake': 'Dose - acceptance',
  'Description': 'Description',
  'Recurrency Type': 'Recurrency Type',
  'Notification Type': 'Notification Type',
  'Notifications': 'Notifications',
  'Date': 'Date',
  'Time': 'Time',
  'Notes': 'Notes',
  'Active': 'Active',
  'Frequency': 'Frequency',
  'Occurs once at': 'Occurs once at',
  'Occurs every hour(s)': 'Occurs every hour(s)',
  'Starting at': 'Starting at',
  'Ending at': 'Ending at',
  'Recurs every': 'Recurs every',
  'Recurs every(f)': 'Recurs every',
  'day(s)': 'day(s)',
  'week(s)': 'week(s)',
  'month(s)': 'month(s)',
  'OneTime': 'One Time',
  'Recurring': 'Recurring',
  'Daily': 'Daily',
  'Weekly': 'Weekly',
  'Monthly': 'Monthly',
  'ToMyFriends': 'Relation\'s list ',
  'Son': 'Son',
  'Daughter': 'Daughter',
  'Father': 'Father',
  'Mother': 'Mother',
  'Sister': 'Sister',
  'Brother': 'Brother',
  'Husband': 'Husband',
  'Wife': 'Wife',
  'Other': 'Other',
  'RelationType': 'Relation Type',
  'AddindFamily': 'Adding relation',
  'Occurs on': 'Occurs on',
  'at': 'at',
  'Occurs every': 'Occurs every',
  'Schedule will be used between': 'Schedule will be used between',
  'and': 'and',
  'Schedule will be used starting on': 'Schedule will be used starting on',
  'day': 'day',
  'week': 'week',
  'month': 'month',
  'every': 'every',
  'hour(s) between': 'hour(s) between',
  'EditingFamily': 'Edit relation',
  'UserInfo': 'User information',
  'InfoForUser': 'Information for ',
  'Information': 'Information',
  'DriveMachine': 'Driving / Machine',
  'When driving': 'When driving',
  'When using machine': 'When using machine',
  'My Condition': 'My Condition',
  'My Profile': 'My Profile',
  'Settings': 'Settings',
  'BloodPressure': 'Blood Pressure',
  'HeartRate': 'Heart Rate',
  'Height': 'Height',
  'Weight': 'Weight',
  'On': 'On',
  'Every': 'Every',
  'Notification': 'Notification',
  'Once at': 'Once at',
  'Every hour(s)': 'Every hour(s)',
  'AddCondition': 'Add Condition',
  'EditCondition': 'Edit Condition',
  'Condition': 'Condition',
  'Value': 'Value',
  'ConditionInList': 'The following condtition/s is/are already in your list',
  'ConditionConfirm': 'Are you sure, that you want to delete the characteristic and all values',
  'See': 'See',
  'Unit': 'Unit',
  'EnterHeight': 'Enter height (170)',
  'EnterWeight': 'Enter weight (70)',
  'EnterBloodPressure': 'Enter blood pressure (140/80)',
  'EnterHeartRate': 'Enter heart rate (60)',
  'EnterDesc': 'Description (headache, stomach ache)',
  'EnterHemoglobin': 'Enter Hemoglobin (140)',
  'ViewCond': 'View condition',
  'for': 'for',
  'medicine': 'medicine',
  'prescription': 'prescription',
  'Language': 'Language',
  'AddNewCondition': 'Add new condition',
  'Filters': 'Filters',
  'NotAllEntered': 'Please enter all values',
  'MedicinesForPrescription': "Medicines for prescription",
  'DiseasesForPrescription': "Diseases for prescription",
  'Legend': 'Legend',
  'PushNotification': 'Notification',
  'Receive Push Notifications': 'Receive Push Notifications',
  'User Settings': 'User Settings',
  'You have to be logged in to activate Notifications.': 'You have to be logged in to activate Notifications.',
  'Bulgarian': 'Bulgarian',
  'English': 'English',
  'You have successfully subscribed for Notifications.': 'You have successfully subscribed for Notifications.',
  'You have successfully unsubscribed from Notifications.': 'You have successfully unsubscribed from Notifications.',
  'Failed to unsubscribe from Push Notifications:': 'Failed to unsubscribe from Push Notifications:',
  'Failed to subscribe for Push Notifications:': 'Failed to subscribe for Push Notifications:',
  'Sunday': 'Sunday',
  'Monday': 'Monday',
  'Tuesday': 'Tuesday',
  'Wednesday': 'Wednesday',
  'Thursday': 'Thursday',
  'Friday': 'Friday',
  'Saturday': 'Saturday',
  'sunday': 'sunday',
  'monday': 'monday',
  'tuesday': 'tuesday',
  'wednesday': 'wednesday',
  'thursday': 'thursday',
  'friday': 'friday',
  'saturday': 'saturday',
  'on': 'on',
  'Every(f)': 'Every',
  'Hourly': 'Hourly',
  'Alarm Time': 'Alarm Time',
  'hour(s)': 'hour(s)',
  'hour': 'hour',
  'between': 'between',
  'starting on': 'starting on',
  'from': 'from',
  "ActiveА": "Active",
  "NotActive": "Not Active",
  'Deleted Successfully': "Deleted Successfully",
  'Data Saved Successfully': "Data Saved Successfully",
  'Medicines of': "Medicines of",
  'Diseases of': 'Diseases of',
  'Menu': 'Menu',
  'Of': 'of',
  'Confirm Message': 'Are you sure, that you want to delete',
  'This record': 'this record',
  'And medicines diseases notifications': ' and its medicines, notifications and diseases',
  'Are you sure you want to logout': 'Are you sure you want to logout?',
  'No disease selected': 'No disease selected',
  'No medicine selected': 'No medicine selected',
  '5004': 'User prescription not found',
  '5005': 'User notification not found',
  '5006': 'Alarm date not valid',
  '5007': 'Notification scheduler not found',
  '6000': 'Active ingredient not found',
  '6001': 'Side effect item not valid',
  '6002': 'Dosage content item not valid',
  '6003': 'Disease not found',
  '6004': 'Food or alcohol item not found',
  '6005': 'Inactive ingredient not found',
  '6006': 'Manufacturer not found',
  '6007': 'Pregnancy or breastfeeding item not valid',
  '6008': 'Drive or machine item not valid',
  '6009': 'Safety data item not valid',
  'Do you want to activate notification on this device': 'Do you want to activate notification on this device',
  'Alarm time cannot be empty': 'Alarm time cannot be empty',
  'Date cannot be empty': 'Date cannot be empty',
  'Alarm date and/or time': 'Alarm date and/or time',
  'are lesser than current time': 'are lesser than current time',
  'Alarm will never execute': 'Alarm will never execute',
  'Please choose frequency': 'Please choose frequency',
  'Please choose counter': 'Please choose counter',
  'Start date cannot be empty': 'Start date cannot be empty',
  'Start date is greater than end date': 'Start date is greater than end date',
  'End date is lesser than today': 'End date is lesser than today',
  '5008': 'Alarm date has expired',
  'Are you sure that you want to delete this record': 'Are you sure that you want to delete this record?',
  ' Medicine will be removed from prescription ': ' Medicine will be removed from prescription ',
  ' Disease will be removed from prescription ': ' Disease will be removed from prescription ',
  'Please select disease': 'Please select disease',
  'Please select medicine': 'Please select medicine',
  '6010': 'File not found',
  '6011': 'Professional content not found',
  '6012': 'Pregnancy and breastfeeding item not found',
  '6013': 'Drive and machine item not found',
  '6014': 'Side effect item not found',
  '6015': 'Dosage content item not found',
  '6016': 'Interaction item not found',
  'Please enter a valid e-mail address.': 'Please enter a valid e-mail address.',
  'Please enter personal name.': 'Please enter personal name.',
  '6 characters or more, at least 1 alphabetical and 1 numeric.': '6 characters or more, at least 1 alphabetical and 1 numeric.',
  'Please enter password again.': 'Please enter password again.',
  'Password must be at least 6 characters and contain at least 1 alphabetical and 1 numeric character': 'Password must be at least 6 characters and contain at least 1 alphabetical and 1 numeric character',
  'You have to take medicines at': 'You have to take medicines at',
  'oclock on date': "o'clock on date",
  '5009': 'Medicine history item not found',
  '5010': 'Disease history item not found',
  'No records found': 'No records found',
  'total records.': 'total records.',
  'current medicine history.': 'current medicine history.',
  'current disease count.': 'current disease count.',
  'have to take his/hers medicines at': 'have to take his/hers medicines at',
  'current prescriptions.': 'current prescriptions.',
  'You don\'t have new notifications': 'You don\'t have new notifications.',
  'You don\'t have old notifications': 'You don\'t have old notifications.',
  'See All': 'See all',
  'Search': "Search",
  'Check medicine interactions': 'Check medicine interactions',
  'List of all Diseases': 'List of all Diseases',
  'Find nearest Pharmacy': 'Find nearest Pharmacy',
  'Pharmacies': 'Pharmacies',
  'Choose characteristic': 'Choose characteristic',
  'Name of characteristic': 'Name of characteristic',
  'New characteristic': 'New characteristic',
  'DateTimeFormat': 'dd/MM/yyyy HH:mm',
  'DateFormat': 'dd/MM/yyyy',
  'SearchDiseaseInDatabase': 'Search by disease name',
  'Characteristic already exist': 'Characteristic already exist',
  'Your characteristics': 'Your characteristics',
  'Characteristic is used': 'Characteristic is used in previous condition/s and can not be deleted',
  'Test is used': 'Test is used in previous lab result/s and can not be deleted',
  'BeforeEating': 'Before Eating',
  'WhileEating': 'While Eating',
  'AfterEating': 'After Eating',
  'Choose acceptance': 'The medicine is taken',
  'Specification of intake': 'Medicine intake',
  'No Intake': 'There is no recorded intake',
  'Mark all as seen': 'Mark all as seen',
  'SendNotification': 'Send notification to',
  'IfItsNotTaken': 'If it is not taken after',
  'Five': '5 minutes',
  'Ten': '10 minutes',
  'Fifteen': '15 minutes',
  'Twenty': '20 minutes',
  'Thirty': '30 minutes',
  'Sixty': '1 hour',
  'UserCreated': 'Create new user',
  'Caretaker': 'Choose assistant',
  'SearchUserInDatabase': 'Search by email',
  'EnterUserName': 'Name or email',
  'AlreadyExist': 'The user is already in your list',
  'You have successfully accept invitation': 'You have successfully accept invitation',
  'Confirm': 'Confirmation',
  'taken at': 'taken at',
  'Waiting': 'Waiting for confirmation',
  'Approved': 'Assistant',
  'EnterAddressOrCity': 'Address or city',
  'DisposalPlaces': 'Places to dispose of drugs',
  'Find nearest Disposal place': 'Find nearest disposal place',
  'Your location': 'Your location',
  'Not allowed food and drinks': 'Not allowed food and drinks',
  'Information about': 'Information about',
  'ATC code': 'ATC code',
  'Мolecular Formula': 'Мolecular Formula',
  'starts with': 'starts with',
  'contain text': 'contain text',
  'All medicines': 'All medicines',
  'contain': 'contain',
  'Recommended food and drinks': 'Recommended food and drinks',
  'Treatment recommendations': 'Treatment recommendations',
  'Course of treatment': 'Course of treatment',
  'Start date course of treatment': 'Start date course of treatment',
  'End date course of treatment': 'End date course of treatment',
  'Allergies': 'Allergies',
  'Porduct Number': 'Porduct Number',
  'Filtering': 'Filter',
  'Authorised': 'Authorised',
  'Withdrawn': 'Withdrawn',
  'Refused': 'Refused',
  'Pending': 'Pending',
  'Suspended': 'Suspended',
  'From': 'From',
  'To': 'To',
  'Prescription From Doctor': 'Prescription from doctor',
  'This medicine is attached to prescription': 'This medicine is attached to precsctiption from doctor',
  'This disease is attached to prescription': 'This disease is attached to precsctiption from doctor',
  'Temperature': 'Temperature',
  'BloodSugar': 'Blood Sugar',
  'EnterTemperature': 'Enter Temperature (36.6)',
  'EnterBloodSugar': 'Enter Blood Sugar (4.8)',
  'PersonalConditionConfirm': 'Are you sure that you want to delete the selected personal characteristic?',
  'Characteristic': 'Characteristic',
  'Characteristics': 'Characteristics',
  'All conditions': 'All conditions',
  'DataSource': 'Data Source',
  'EMA': 'European Medicines Agency',
  'BDA': 'Bulgarian Drug Agency',
  'New': 'New',
  'Old': 'Old',
  'Add Characteristic': 'Add values',
  'New Characteristic': 'New Characteristic',
  'Chatbot': 'Chatbot',
  'Doctors prescriptions': 'Doctors prescriptions',
  'Doctors prescription': 'Doctors prescription',
  'Diet': 'Diet',
  'Life mode': 'Life mode',
  'Hemoglobin': 'Hemoglobin',
  'Laboratory result': 'Laboratory result',
  'Add Laboratory result': 'Add laboratory result',
  'Edit laboratory Result': 'Edit laboratory result',
  'Add Lab result': 'Add laboratory result',
  'New laboratory test': 'New laboratory test',
  'Choose test': 'Choose test',
  'LaboratoryResultConfirm': 'Are you sure you want to delete laboratory result for',
  'PersonalTestConfirm': 'Are you sure you want to delete the selected personal laboratory test?',
  'Files': 'Files',
  'Add files': 'Add files',
  'FileRemove': 'Are you sure you want to remove the selected file?',
  'Allowed file types are': 'Allowed file types are',
  'File size is greater than': 'File size is greater than',
  'Min': 'Min value',
  'Max': 'Max value',
  'laboratoryResultInList': 'The test is already in list',
  'AgeAbb': 'age',
  'Age': 'Age',
  'Reference values': 'Reference values',
  'All Laboratory Results': 'All Laboratory Results',
  'Yours reference values': 'Yours reference values',
  'Allowed formats': 'Allowed formats',
  'Max total file size': 'Max total file size',
  'TotalCholesterol': 'Total Cholesterol',
  'HighDensityLipoproteinCholesterol': 'HDL Cholesterol',
  'LowDensityLipoproteinCholesterol': 'LDL Cholesterol',
  'Triglycerides': 'Triglycerides',
  'EnterTotalCholesterol': 'Enter Total Cholesterol(3.2)',
  'EnterHDL': 'Enter HDL-Cholesterol(2.1)',
  'EnterLDL': 'Enter LDL-Cholesterol(2.5)',
  'EnterTriglycerides': 'Enter Triglycerides(4.3)',
  'LabTest': 'Test',
  'Enter valid value': 'Enter valid value',
  'Scan': 'Scan',
  'The connection was interrupted': 'The connection was interrupted',
  'Connect with a device': 'Connect with a Bluetooth (LE) devices',
  'Current value': 'Current value',
  'No current value': 'Scan for devices. From the list of available devices choose the desired and pair with it',
  'BloodPresureValid': 'Make sure the value is correctly entered (140/80)',
  'BloodPresureExample': 'Example: 140/80',
  'BottomNumber': 'Bottom number',
  'TopNumber': 'Top number',
  'AddValue': 'Add value',
  '11003': 'User lab result item not found',
  'Enter name or select alpha index': 'Enter name or select letter',
  'TotalResults': 'total results',
  'ReceivingData': 'Receiving data...',
  'ReceivedData': 'Received data',
  'BottomNumberBigger': 'Bottom number can not be with bigger value than the top number',
  'OneDay': '1 day',
  'OneWeek': '1 week',
  'OneMonth': '1 month',
  'ThreeMonths': '3 months',
  'SixMonths': '6 months',
  'OneYear': '1 year',
  'Advanced': 'Advanced',
  'Period': 'Period',
  'All Results': 'All results',
  'Snooze': 'Snooze',
  'min.': 'min',
  'snoozed for': 'snoozed for',
  'Take': 'Take',
  'Minutes': 'minutes',
  'InCaseThat': 'if the medicine is not taken after',
  'SendNotificationsTo': 'Send a notification to',
  'NormInfoPopMessage': 'Norm selection is determined by your personal data',
  'User Functionalities': 'User\'s Functionalities',
  'Pregnancy and Breastfeeding': 'Pregnancy, breastfeeding and fertility',
  'DrivingAndUsingMachines': 'Diving and using machine',
  'EPAR': 'Summary of product characteristics and Package leaflet',
  'All diseases': 'All diseases',
  'Enter birht date': 'Enter birht date',
  'Locations': 'Locations',
  '4007': 'User not authenticated',
  'current doctors prescriptions.': 'current prescription(s).',
  'doctor': 'doctor',
  'Doctors prescription from doctor': 'Prescription from doctor',
};

export default en;